import { render, staticRenderFns } from "./showdelis.vue?vue&type=template&id=027e76e3&scoped=true&"
import script from "./showdelis.vue?vue&type=script&lang=js&"
export * from "./showdelis.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "027e76e3",
  null
  
)

export default component.exports